import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import FieldLabel from './field-label'

import styles from './field-group.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipClassName: PropTypes.string
}

function FieldGroup({ children, className, label, tooltip, tooltipClassName }) {
    return (
        <div className={cx(styles['field-group'], className)}>
            {renderChildren(children, label, tooltip, tooltipClassName)}
        </div>
    )
}

FieldGroup.propTypes = propTypes

function renderChildren(children, label, tooltip, tooltipClassName) {
    return label ? <FieldLabel {...{ label, tooltip, tooltipClassName }}>{children}</FieldLabel> : children
}

export default FieldGroup
